var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaypal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.96 24.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#003087;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#009cde;}.cls-3{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.33,6.74a4,4,0,0,0-3.07-1h-4a.57.57,0,0,0-.57.49L15,16.86a.34.34,0,0,0,.34.4h2.48l.62-4,0,.13a.57.57,0,0,1,.57-.49h1.18c2.31,0,4.12-.94,4.65-3.66a2.23,2.23,0,0,0,0-.23,2.57,2.57,0,0,0-.54-2.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.58,9.66c-.6,2.68-2.47,4.09-5.4,4.09h-1l-.68,4.31H17.7l0,.28a.3.3,0,0,0,.3.35h2.09a.51.51,0,0,0,.5-.42l0-.11.39-2.5,0-.13a.51.51,0,0,1,.5-.43h.31c2,0,3.61-.82,4.08-3.2a2.89,2.89,0,0,0-.29-2.24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3.85,0H37.11A3.86,3.86,0,0,1,41,3.85V20.6a3.86,3.86,0,0,1-3.85,3.85H3.85A3.86,3.86,0,0,1,0,20.6V3.85A3.86,3.86,0,0,1,3.85,0ZM37.11,1.33H3.85A2.53,2.53,0,0,0,1.33,3.85V20.6a2.49,2.49,0,0,0,.74,1.78,2.52,2.52,0,0,0,1.78.75H37.11a2.54,2.54,0,0,0,2.52-2.53V3.85a2.53,2.53,0,0,0-2.52-2.52Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.1db12d7b1c0728381db3be1b11bb22a2.svg";
export { ForwardRef as ReactComponent };